import { object, string } from 'yup';

export type IResidentInvoicingRemark = {
  remark?: string | null;
};

export const IResidentInvoicingRemarkSchema = object({
  remark: string().nullable().optional(),
});
